import { Grid } from "@mui/material";
import React from "react";
import { getAssets } from "@unisearch/helpers";
import styles from "./document_banner2.module.scss";
import Image from "next/legacy/image";

const DocumentBanner2 = () => {
  return (
    <div className={styles.wrapper}>
      <div className="container">
        <Grid container spacing={{ xs: 2, sm: 2, md: 5 }} alignItems="center">
          <Grid item xs={12} sm={12} md={6}>
            <h4>Everything You Need to Know</h4>
            <h1>
              {/* Prepeard your <br /> <span className="mark">Documents</span> */}
              To Build A Successful <span className="mark">Application</span>
            </h1>
          </Grid>
          <Grid item md={6}>
            <Image
              layout="responsive"
              width={565}
              height={416}
              blurDataURL={getAssets(
                "assets/images/study/country_placeholder.webp"
              )}
              placeholder="blur"
              src={getAssets("/assets/images/documents/banner1.webp")}
              alt="library"
            />
          </Grid>
        </Grid>
      </div>
    </div>
  );
};

export default DocumentBanner2;
